import cn from "classnames"

import { Flex, Text } from "@/atoms"
import { Trans, useTranslation } from "@/hooks/useTranslation"
import { InfoCircleOutlined } from "@/icons"
import { Description } from "@/pages/TriagePage/components/pages/AdrPage/components/Description"
import {
  getEnforcementValues,
  getTranslations,
  getValues,
  translationsWithVM
} from "@/pages/TriagePage/components/pages/AdrPage/helpers"
import { AdrTabTemplate } from "@/pages/TriagePage/components/templates/AdrTabTemplate"
import { OverviewStepsAdr } from "../OverviewStepsAdr"

import styles from "./OverviewTabAdr.module.scss"

import type { AdrIncident } from "@/domain/adr"

export const OverviewTabAdr = (props: { incident: AdrIncident }) => {
  const { incident } = props
  const { what, where, type } = incident
  const keyPrefix = `triage.adr.incidents.${type}.overview`
  const { t } = useTranslation("translation", { keyPrefix })
  const { t: tAll } = useTranslation()

  const values = getValues({
    ...what,
    ...where,
    ...getEnforcementValues(incident),
    ...getTranslations(incident, tAll)
  })
  const attr = { values, t }
  const what2 = t("what2", values)
  const info = translationsWithVM("why.info", incident, attr)

  return (
    <AdrTabTemplate classes={{ container: styles.container }}>
      <OverviewStepsAdr incident={incident} />
      <Description title="What happened">
        <Text className={styles.section}>
          <Trans>{translationsWithVM("what", incident, attr)}</Trans>
        </Text>
        {what2 && (
          <Text className={styles.section}>
            <Trans>{what2}</Trans>
          </Text>
        )}
      </Description>
      <Description title="Why it matters">
        <Flex vertical gap={2}>
          <Text className={styles.section}>
            <Trans>{translationsWithVM("why.text", incident, attr)}</Trans>
          </Text>
          {info && (
            <Text type="secondary" className={cn("sm-text-ks", styles.info)}>
              <span>
                <InfoCircleOutlined />
              </span>
              <span>{info}</span>
            </Text>
          )}
        </Flex>
      </Description>
    </AdrTabTemplate>
  )
}
